<template>
  <div>
    <span v-if="analysisPass" class="d-flex justify-center gap-1">
      <IconTooltip :icon="reviewPassed.icon" :description="reviewPassed.description" :color="reviewPassed.color" />
    </span>
    <span v-else>
      <span v-if="hasAnalysis" class="d-flex justify-center gap-1">
        <IconTooltip :icon="value.icon" :description="value.description" :color="value.color" />
        <IconTooltip :icon="document.icon" :description="document.description" :color="document.color" />
        <IconTooltip :icon="cnae.icon" :description="`${cnae.description} ${cnaeCode} ${cnaeDescription}`" :color="cnae.color" />
      </span>
      <span v-else class="d-flex justify-center gap-1">
        <IconTooltip icon="mdi-currency-usd" :description="reviewUnavailable" color="grey" />
        <IconTooltip icon="mdi-home-city-outline" :description="reviewUnavailable" color="grey" />
        <IconTooltip icon="cnae" :description="reviewUnavailable" color="grey" />
      </span>
    </span>
  </div>
</template>

<script>
import IconTooltip from '@/components/IconTooltip'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'InvoiceAutomaticValidationIcons',

  components: {
    IconTooltip,
  },

  props: {
    invoice: {
      type: Object,
      required: false,
    },
  },

  computed: {
    hasAnalysis() {
      return !!this.invoice?.invoice_file_analysis
    },

    analysisPass() {
      if (!this.hasAnalysis) return false

      return this.invoice?.invoice_file_analysis?.value_matches &&
        this.invoice?.invoice_file_analysis?.receiver_document_matches &&
        this.invoice?.invoice_file_analysis?.cnae_matches
    },

    value() {
      return this.invoice?.invoice_file_analysis?.value_matches
        ? this.valueMatches
        : this.valueNotMatches
    },

    document() {
      return this.invoice?.invoice_file_analysis?.receiver_document_matches
        ? this.documentMatches
        : this.documentNotMatches
    },

    cnae() {
      return this.invoice?.invoice_file_analysis?.cnae_matches
        ? this.cnaeMatches
        : this.cnaeNotMatches
    },

    cnaeCode() {
      if (!this.invoice?.invoice_file_analysis?.cnae_matches) return ''
      return ` - ${this.invoice?.invoice_file_analysis?.cnae_code}`
    },

    cnaeDescription() {
      if (!this.invoice?.invoice_file_analysis?.cnae_matches) return ''
      return ` | ${this.invoice?.invoice_file_analysis?.cnae_description}`
    },

    reviewUnavailable() {
      return this.$t('hausefulInvoices.messages.reviewUnavailable')
    },
  },

  methods: {
    amountValue() {
      return catalogMonetary(this.invoice?.invoice_file_analysis?.value ?? 0)
    },

    amountInvoiceValue() {
      return catalogMonetary(this.invoice?.total ?? 0)
    },

    buildAmountText() {
      return this.$t('hausefulInvoices.messages.valueNotMatches', { amountValue: this.amountValue(), amountInvoiceValue: this.amountInvoiceValue() })
    },
  },

  data() {
    return {
      reviewPassed: {
        color: 'green',
        icon: 'mdi-check',
        description: this.$t('hausefulInvoices.messages.reviewPassed'),
      },

      valueMatches: {
        color: 'green',
        icon: 'mdi-currency-usd',
        description: this.$t('hausefulInvoices.messages.valueMatches'),
      },

      valueNotMatches: {
        color: 'red',
        icon: 'mdi-currency-usd',
        description: this.buildAmountText(),
      },

      documentMatches: {
        color: 'green',
        icon: 'mdi-home-city-outline',
        description: this.$t('hausefulInvoices.messages.documentMatches'),
      },

      documentNotMatches: {
        color: 'red',
        icon: 'mdi-home-city-outline',
        description: this.$t('hausefulInvoices.messages.documentNotMatches'),
      },

      cnaeMatches: {
        color: 'green',
        icon: 'cnae',
        description: this.$t('hausefulInvoices.messages.cnaeMatches'),
      },

      cnaeNotMatches: {
        color: 'red',
        icon: 'cnae',
        description: this.$t('hausefulInvoices.messages.cnaeNotMatches'),
      },
    }
  }
}
</script>
